import { useTranslation } from "react-i18next";

import { Alert, Stack } from "@mui/material";

import { ClientContent } from "../../../client-content/ClientContent";
import { useClientFileContext } from "../../../context/ClientFileContext";
import { ChecklistQuestion } from "../checklist-question/ChecklistQuestion";
import { FormattedText } from "../formatted-text/FormattedText";
import { ChecklistSectionCard } from "../section-card/ChecklistSectionCard";
import { getQuestionStates } from "./BankruptcyConsequences.utils";
import { useBankruptcyConsequences } from "./hooks/useBankruptcyConsequences";

const BASE = "clients.client.debtSettlement.bankruptcyChecklist.bankruptcyConsequences";

export function BankruptcyConsequences() {
  const { t } = useTranslation();
  const { clientId } = useClientFileContext();
  const { formik, setAnswer } = useBankruptcyConsequences(clientId);

  const values = formik.values;
  const states = getQuestionStates(values);

  return (
    <ClientContent formik={formik}>
      <Stack gap={2}>
        <Alert severity="info" sx={{ border: 1, borderColor: "info.light" }}>
          <FormattedText text={t(`${BASE}.intro`)} />
        </Alert>

        <ChecklistSectionCard title={t(`${BASE}.sections.girokonto`)}>
          <ChecklistQuestion
            question={t(`${BASE}.questions.eigenesGirokonto`)}
            value={values.hasOwnCheckingAccount}
            onChange={(value) => setAnswer("hasOwnCheckingAccount", value)}
            info={t(`${BASE}.info.infoKonto`)}
            conditionalInfo={values.hasOwnCheckingAccount === true ? t(`${BASE}.info.kontoJa`) : undefined}
          />
          {states.isCheckingAccountOverdrawn.visible && (
            <ChecklistQuestion
              question={t(`${BASE}.questions.kontoUeberzogen`)}
              value={values.isCheckingAccountOverdrawn}
              onChange={(value) => setAnswer("isCheckingAccountOverdrawn", value)}
              conditionalInfo={values.isCheckingAccountOverdrawn === true ? t(`${BASE}.info.minusInfo`) : undefined}
            />
          )}
        </ChecklistSectionCard>

        <ChecklistSectionCard title={t(`${BASE}.sections.mobiltelefon`)}>
          <ChecklistQuestion
            question={t(`${BASE}.questions.mobiltelefon`)}
            value={values.hasRegisteredMobilePhone}
            onChange={(value) => setAnswer("hasRegisteredMobilePhone", value)}
            conditionalInfo={values.hasRegisteredMobilePhone === true ? t(`${BASE}.info.handyInfo`) : undefined}
          />
        </ChecklistSectionCard>

        <ChecklistSectionCard title={t(`${BASE}.sections.stromGas`)}>
          <ChecklistQuestion
            question={t(`${BASE}.questions.stromEigenerName`)}
            value={values.isElectricityInOwnName}
            onChange={(value) => setAnswer("isElectricityInOwnName", value)}
            conditionalInfo={values.isElectricityInOwnName === true ? t(`${BASE}.info.stromInfo`) : undefined}
          />
        </ChecklistSectionCard>

        <ChecklistSectionCard title={t(`${BASE}.sections.fernwaerme`)}>
          <ChecklistQuestion
            question={t(`${BASE}.questions.wohnungFernwaerme`)}
            value={values.isApartmentDistrictHeated}
            onChange={(value) => setAnswer("isApartmentDistrictHeated", value)}
          />
          {states.isDistrictHeatingInOwnName.visible && (
            <ChecklistQuestion
              question={t(`${BASE}.questions.fernwaermeEigenerName`)}
              value={values.isDistrictHeatingInOwnName}
              onChange={(value) => setAnswer("isDistrictHeatingInOwnName", value)}
              conditionalInfo={values.isDistrictHeatingInOwnName === true ? t(`${BASE}.info.fernwInfo`) : undefined}
            />
          )}
        </ChecklistSectionCard>
      </Stack>
    </ClientContent>
  );
}
